const contactGetErrorMessage = ({ message, intl }) => {
  switch (message) {
    case "validation_failed": {
      return intl.formatMessage({
        defaultMessage:
          "Une erreur est survenue lors de l’envoi de votre message. Merci de vérifier les erreurs dans le formulaire.",
      });
    }

    default: {
      return message;
    }
  }
};

export default contactGetErrorMessage;
